// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__SYM0_","footer":"ModalInfo_footer__2Jk8I"};